import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { OktaAuthStateService } from '@okta/okta-angular';
import { AuthState } from '@okta/okta-auth-js';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenProviderService {
  private oktaStateService = inject(OktaAuthStateService);

  oktaState$ = this.oktaStateService.authState$.pipe(
    filter((authState: AuthState) => !!authState),
  );

  oktaState = toSignal(this.oktaState$, {
    initialValue: { isAuthenticated: false } as AuthState,
  });

  readonly idToken = computed(() => this.oktaState().idToken?.idToken);
  readonly rawIdToken = computed(() => this.oktaState().idToken);
  readonly accessToken = computed(() => this.oktaState().accessToken);
}
